if (!customElements.get('rocket-artistas-tabs')) {
  customElements.define(
    'rocket-artistas-tabs',
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Wait a bit for all dynamic content to be rendered
        setTimeout(() => {
          this.tabs = this.querySelectorAll('.rocket-artistas__tab');
          this.groups = this.querySelectorAll('.rocket-artistas__group');
          this.searchInput = this.querySelector('#rocketSearchInput');

          this.bindEvents();
        }, 100);
      }

      bindEvents() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const tabValue = tab.getAttribute('data-tab');
            const isActive = tab.classList.contains('rocket-artistas__tab--active');
          
            // Clear search input
            if (this.searchInput) this.searchInput.value = '';
          
            if (isActive) {
              this.groups.forEach((group) => {
                group.style.display = 'block';
              });
          
              this.tabs.forEach((t) => t.classList.remove('rocket-artistas__tab--active'));
            } else {
              this.groups.forEach((group) => {
                group.style.display = 'none';
              });
          
              this.tabs.forEach((t) => t.classList.remove('rocket-artistas__tab--active'));
          
              const selectedGroup = this.querySelector(`.rocket-artistas__group[data-tab-content="${tabValue}"]`);
              if (selectedGroup) {
                selectedGroup.style.display = 'block';
              }
          
              tab.classList.add('rocket-artistas__tab--active');
            }
          });
        });

        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.rocketSearchartistas());
        }
      }

      rocketSearchartistas() {
        const query = this.searchInput.value.toLowerCase();
        const hasQuery = query.length > 0;
        this.groups.forEach((group) => (group.style.display = 'none'));
        this.tabs.forEach((tab) => tab.classList.remove('rocket-artistas__tab--active'));

        if (query) {
          this.groups.forEach((group) => {
            const content = group.textContent.toLowerCase();
            const items = group.querySelectorAll('.rocket-artis-wrapper');
            items.forEach((item) => {
              const itemCheck = item.querySelector('.rocket-artistas__item');
              if (itemCheck) {
              const content = itemCheck.textContent.toLowerCase();
              const match = hasQuery ? content.includes(query) : true;
              item.style.display = match ? 'block' : 'none';
              }
            });
            const tabValue = group.getAttribute('data-tab-content');
            const tab = this.querySelector(`.rocket-artistas__tab[data-tab="${tabValue}"]`);

            if (content.includes(query)) {
              group.style.display = 'block';
            }
          });
        } else {
          this.groups.forEach((group) => (group.style.display = 'block'));
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
    let allArtisLinks = document.querySelectorAll('.rocket-artistas-item');

    allArtisLinks.forEach((link) => {
      let linkHref = link.querySelector('.metafield-collection_reference');
      if (linkHref) {
        linkHref.style.display = 'none';

        let linkNeed = link.querySelector('.rocket-artistas__item');
        if (linkNeed) {
          linkNeed.setAttribute('href', linkHref.getAttribute('href'));
        }
      }
    });
    

    let allArtisLinks2 = document.querySelectorAll('.rocket-artis-wrapper');

    allArtisLinks2.forEach((link) => {
      let linkHref2 = link.querySelector('.metafield-collection_reference');
      if (linkHref2) {
        linkHref2.style.display = 'none';

        let linkNeed2 = link.querySelector('.rocket-artistas__item');
        if (linkNeed2) {
          linkNeed2.setAttribute('href', linkHref2.getAttribute('href'));
        }
      }
    });
});